import { useToasts } from "@/lib/toast";
import { cn } from "@/lib/cn";

export default function Toasts() {
  const toasts = useToasts();
  return (
    <div className="pointer-events-none fixed inset-x-0 top-3 z-50 flex flex-col items-center gap-2 px-4">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            "pointer-events-auto max-w-md rounded-lg px-4 py-2 text-sm shadow-lg",
            t.kind === "error" && "bg-destructive text-destructive-foreground",
            t.kind === "success" && "bg-primary text-primary-foreground",
            t.kind === "info" && "bg-card text-card-foreground border border-border",
          )}
        >
          {t.message}
        </div>
      ))}
    </div>
  );
}
